import demandsAPI from '.'
import qs from 'qs'

export async function getDemands({ page, limit, search = '', ...filters }) {
	const { data } = await demandsAPI.get(`/tasks/list`, {
		params: {
			page,
			limit,
			search,
			...filters,
		},
	})

	return data
}

const formatOptions = (list) => {
	if (!Array.isArray(list)) return []
	return list.map((item) => ({
		label: item.name,
		value: item.id,
	}))
}

export async function getCategoriesOptions(search = '') {
	const { data } = await demandsAPI.get(`/filters/categories?search=${search}`)
	return formatOptions(data.list)
}

export async function getTemplatesOptions(search = '') {
	const { data } = await demandsAPI.get(`/filters/templates?search=${search}`)
	return formatOptions(data.list)
}

export async function getUsersOptions(search = '') {
	const { data } = await demandsAPI.get(`/filters/users?search=${search}`)
	return formatOptions(data.list)
}

export async function getSolicitantAreasOptions(search = '') {
	const query = typeof search === 'string' ? search : ''
	const { data } = await demandsAPI.get(
		`/filters/solicitant-areas?search=${search}`
	)
	const list = data.list || []
	return list.map((item) => ({
		label: item.name,
		value: item.id,
	}))
}

export async function updateStatus({ id, status }) {
	const { data } = await demandsAPI.post(`/tasks/update-status`, {
		taskId: id,
		status,
	})

	return data
}

export async function listResponsibles(
	page = 1,
	limit = 10,
	search,
	teamId = ''
) {
	const { data } = await demandsAPI.get('/users/list', {
		params: { page, limit, search, teamId },
	})

	return data
}

export async function setResponsible({ taskId, userId }) {
	const { data } = await demandsAPI.post('/tasks/claim-ownership', {
		taskId,
		userId,
	})

	return data
}

export async function getOptions({ route, page = 1, limit = 10 }) {
	const { data } = await demandsAPI.get(`${route}?page=${page}&limit=${limit}`)

	return data
}

export async function createDemand(payload) {
	try {
		const response = await demandsAPI.put('/tasks/create', payload)

		if (!response) {
			throw new Error('A API não retornou uma resposta válida.')
		}

		return response.data
	} catch (error) {
		console.error('Erro ao criar demanda:', error)
		throw error
	}
}

export async function updateDemand(payload) {
	const { data } = await demandsAPI.post('/tasks/update', payload)

	return data
}

export async function getDemandById(id) {
	if (!id) {
		return null
	}

	try {
		const response = await demandsAPI.get(`/tasks/${id}`)
		return response.data
	} catch (error) {
		console.error(`Erro ao buscar demanda com ID ${id}:`, error)
		throw error
	}
}

export async function listMessages(taskId, skip = 0) {
	return await demandsAPI.get(`/tasks/messages/${taskId}/${skip}`)
}

export async function createMessage(taskId, formData) {
	const { data } = await demandsAPI.post(
		`/tasks/messages/create/${taskId}`,
		formData
	)

	return data
}

export async function getTaskAttachments(taskId) {
	const { data } = await demandsAPI.get(`/tasks/list-attachments/${taskId}`)

	return data
}

export async function downloadAttachment(attachmentId) {
	const { data } = await demandsAPI.post(
		`/tasks/download-attachments/${attachmentId}`
	)

	return data
}

export async function downloadMessageAttachment(demandId, messageId) {
	const { data } = await demandsAPI.get(
		`/tasks/messages/download-attachments/${demandId}/${messageId}`,
		{ responseType: 'blob' }
	)

	return data
}

export async function getDashboardData(startDate, endDate, filters = {}) {
	const cleanFilters = { ...filters }
	if (!cleanFilters.search) delete cleanFilters.search

	const { data } = await demandsAPI.get('/dashboard/list', {
		params: {
			startDate,
			endDate,
			...cleanFilters,
		},

		paramsSerializer: (params) => {
			return qs.stringify(params, { arrayFormat: 'brackets' })
		},
	})

	return data
}

export async function deleteTask(taskId) {
	const { data } = await demandsAPI.delete(`/tasks/delete/${taskId}`)

	return data
}
